import React from "react";
import { Form, Input } from "antd";
import { Link } from "react-router-dom";
import { FormComponentProps } from "antd/lib/form";

import { FormSection } from "../../../molecules";
import { CTAButton, CTAContainer, ExtraCTAContainer } from ".";

interface IRawSignUpFormOwnProps {
  loading: boolean;
  onSignUpAttempt: (implementerName: string, emailAddress: string, password: string) => void;
}

type RawSignUpFormProps = FormComponentProps & IRawSignUpFormOwnProps;

const RawSignUpForm: React.FC<RawSignUpFormProps> = ({ form, loading, onSignUpAttempt }) => {
  const { getFieldDecorator } = form;

  const handleOnSubmit = () => {
    form.validateFields((err, values) => {
      if (err) {
        // TODO: Report to bugsnag
        return;
      }

      onSignUpAttempt(values?.implementerName, values?.emailAddress, values?.password);
    });
  };

  return (
    <Form>
      <FormSection>
        <Form.Item label="Nombre de la implementadora">
          {getFieldDecorator("implementerName", {
            rules: [
              {
                required: true,
                message: "Por favor, ingresa el nombre de tu implementadora."
              }
            ],
          })(
            <Input size="large" disabled={loading} />
          )}
        </Form.Item>
        <Form.Item label="Correo electrónico">
          {getFieldDecorator("emailAddress", {
            rules: [
              {
                required: true,
                message: "Por favor, ingresa el correo electrónico."
              },
              {
                type: "email",
                message: "Por favor, ingresa un correo electrónico válido."
              }
            ],
          })(
            <Input size="large" disabled={loading} />
          )}
        </Form.Item>
        <Form.Item label="Contraseña">
          {getFieldDecorator("password", {
            rules: [
              {
                required: true,
                message: "Por favor, ingresa una contraseña."
              },
              {
                min: 6,
                message: "Usa una contraseña de al menos 6 caracteres."
              }
            ]
          })(
            <Input.Password size="large" disabled={loading} />
          )}
        </Form.Item>
      </FormSection>
      <FormSection>
        <CTAContainer>
          <Form.Item>
            <CTAButton
              shape="round"
              type="primary"
              size="large"
              htmlType="submit"
              onClick={handleOnSubmit}
              loading={loading}>
              Crear cuenta
            </CTAButton>
          </Form.Item>
          <ExtraCTAContainer>
            <span style={{ marginRight: 10 }}>¿Tienes cuenta?</span>
            <Link to="/iniciar-sesion">Inicia sesión</Link>
          </ExtraCTAContainer>
        </CTAContainer>
      </FormSection>
    </Form>
  );
};

export const SignUpForm = Form.create<RawSignUpFormProps>({
  name: "SignUpForm"
})(RawSignUpForm);
